module.exports = __webpack_public_path__ + "media/images/pic07-508a1d33b9238de0f9b247d395ac116d.jpg";